import { ReactComponent as MembershipProfileIconSVG } from "./membership-profile-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconMembershipProfile(props) {
  return <SvgIcon {...props} component={MembershipProfileIconSVG} viewBox="0 0 743 651" />;
}